import { Outlet } from 'react-router-dom';
import { EventJobRunningBanner } from '../../components/Synchronizations/EventJobRunningBanner';

export const SubstitutionsLayout = () => {
  return (
    <>
      <EventJobRunningBanner />
      <Outlet />
    </>
  );
};
